import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Link} from 'react-router-dom';
import "./AllAdminRow.css"
import Modal from "react-bootstrap/es/Modal";
import ModalFooter from "react-bootstrap/es/ModalFooter";
import axios from "axios";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../../configuration";
import MessageBox from "../../../Common/MessageBox/MessageBox";

class AllAdminRow extends Component {

    constructor(props) {
        super(props);
        this.truncate = this.truncate.bind(this);
        this.state = {
            deactivateShow: false,
            activateShow: false,
            status: this.props.adminList.status,
        };

        this.deactivateHandleShow = this.deactivateHandleShow.bind(this);
        this.deactivateHandleShow = this.deactivateHandleShow.bind(this);
        this.userActivation = this.userActivation.bind(this);
    }

    userActivation = (activation) => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/admin/users/activation/' + this.props.adminList.id + '/' + activation, axiosConfig)
            .then((res) => {

                if (res.data === "active") {
                    this.setState({
                        status: 'ACTIVE',
                        activateShow: false
                    }, ()=>this.props.getAllAdmins(0,ITEM_COUNT_PER_PAGE))
                } else {
                    this.setState({
                        status: res.data,
                        deactivateShow: false,
                    }, ()=>this.props.getAllAdmins(0, ITEM_COUNT_PER_PAGE))
                }

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            });

    };

    deactivateHandleShow = () => {
        this.setState({
            deactivateShow: true,
            status:'INACTIVE'

        })
    };
    activateHandleShow = () => {
        this.setState({
            activateShow: true,
            status:'ACTIVE'

        })
    };

    deactivateHandleClose = () => {
        this.setState({
            deactivateShow: false,
        })
    };

    activateHandleClose = () => {
        this.setState({
            activateShow: false,
        })
    };


    truncate(s) {
        if (s.length > 15) {
            return s.substring(0, 12) + "...";
        } else {
            return s;
        }

    };

    render() {
        return (
            <tr>
                <td>{this.props.adminList.name}</td>
                <td>{this.props.adminList.username}</td>
                <td> {this.props.adminList.userRole}</td>
                <td> {this.props.adminList.phone}</td>
                <td>
                    <Link to={"view/" + this.props.adminList.id} className="btn btn-xs btn-warning admin-all-btn-width">
                        <FormattedMessage id="app.admin-all-row.view"
                                          defaultMessage="View"
                                          description=""/>
                    </Link>
                    &nbsp;
                    {/*<Link to={"update/" + this.props.adminList.id} className="btn btn-xs btn-primary">*/}
                    {/*<FormattedMessage id="app.admin-all-row.update"*/}
                    {/*defaultMessage="Update"*/}
                    {/*description=""/>*/}
                    {/*</Link>*/}

                    {/*<button className="btn btn-xs btn-danger" onClick={this.handleShow}>*/}
                    {/*<FormattedMessage id="app.admin-all-row.delete"*/}
                    {/*defaultMessage="Delete"*/}
                    {/*description=""/>*/}
                    {/*</button>*/}

                    {
                        this.props.userId !== this.props.adminList.id ?

                            this.props.adminList.status === "ACTIVE" ?
                                <button className="btn btn-xs btn-danger btn-activation admin-all-btn-width"
                                        onClick={this.deactivateHandleShow}>
                                    <FormattedMessage id="app.admin-all-row.deactivate"
                                                      defaultMessage="Deactivate"
                                                      description=""/>

                                </button>
                                :
                                <button className="btn btn-xs btn-success btn-activation admin-all-btn-width"
                                        onClick={this.activateHandleShow}>
                                    <FormattedMessage id="app.admin-all-row.activate"
                                                      defaultMessage="Activate"
                                                      description=""/>

                                </button>

                            :
                            <div className="div-btn">
                                <Link to={'/profile'}>
                                    <button className="btn btn-xs btn-success btn-activation div-btn-activation admin-all-btn-width">
                                        編集
                                    </button>
                                </Link>
                                {/*<button className="btn btn-xs  btn-danger btn-activation"*/}
                                {/*onClick={this.deactivateHandleShow}>*/}
                                {/*無効に変更*/}
                                {/*</button>*/}

                            </div>


                    }

                    {/*deactivate user ------------------------------*/}
                    <Modal dialogClassName="user-delete-modal" show={this.state.deactivateShow}
                           onHide={this.deactivateHandleClose}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                {/*<FormattedMessage id="app.admin-all-row.deactivate-user"*/}
                                {/*defaultMessage="Deactivate User"*/}
                                {/*description=""/>*/}
                                アカウントの無効設定
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-12 data-label">

                                        {/*<FormattedMessage id="app.admin-all-row.deactivate-confirm"*/}
                                        {/*defaultMessage="Are you sure you want to deactivate the user ?"*/}
                                        {/*description=""/>*/}

                                        アカウントが無効に設定された場合、ログインできなくなります。
                                        <br/>
                                        <br/>
                                        <b><span className='font-color-red-alladmin'>
                                    このアカウントを無効設定してもよろしいでしょうか。

                                    </span></b>
                                    </div>


                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">

                                <button className="btn btn-primary col-md-2 pull-right"
                                        onClick={this.deactivateHandleClose}>
                                    <FormattedMessage id="app.admin-all-row.deactivate-no"
                                                      defaultMessage="No"
                                                      description=""/>
                                </button>
                                <button className="btn btn-success col-md-2 pull-right delete-btn-yes"
                                        onClick={() => this.userActivation(false)}>
                                    <FormattedMessage id="app.admin-all-row.deactivate-yes"
                                                      defaultMessage="Yes"
                                                      description=""/>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    {/*activate user ------------------------------*/}
                    <Modal dialogClassName="user-delete-modal" show={this.state.activateShow}
                           onHide={this.activateHandleClose}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.admin-all-row.activate-user"
                                                  defaultMessage="Activate User"
                                                  description=""/>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-8 data-label">

                                        <FormattedMessage id="app.admin-all-row.activate-confirm"
                                                          defaultMessage="Are you sure you want to activate the user ?"
                                                          description=""/>
                                    </div>


                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">

                                <button className="btn btn-primary col-md-2 pull-right" onClick={this.activateHandleClose}>
                                    <FormattedMessage id="app.admin-all-row.deactivate-no"
                                                      defaultMessage="No"
                                                      description=""/>
                                </button>
                                <button className="btn btn-success col-md-2 pull-right delete-btn-yes"
                                        onClick={() => this.userActivation(true)}>
                                    <FormattedMessage id="app.admin-all-row.deactivate-yes"
                                                      defaultMessage="Yes"
                                                      description=""/>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                </td>
            </tr>

        )
    }


}

export default AllAdminRow;



// WEBPACK FOOTER //
// ./src/components/Admin/AllAdminUsers/AllAdminRow/AllAdminRow.js